import { NewPaymentModal } from "./NewPaymentModal";
import { show } from "@ebay/nice-modal-react";

/** Display the New Payment modal dialog. */
export async function showNewPaymentModal() {
    return await show(NewPaymentModal);
}
